import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BAlert, BButton, BCol, BRow } from "bootstrap-vue";
import { useRouter } from "vue-router/composables";
import localize from "@/utils/localization";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ManageIndexHeader',
    props: {
        message: null,
        createButtonId: null,
        createRoute: null
    },
    setup(__props) {
        library.add(faPlus);
        const router = useRouter();
        return { __sfc: true, router, FontAwesomeIcon, BAlert, BButton, BCol, BRow, localize };
    }
});
